import { TextField } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useState } from "react";

export function MaskedTextField({ defaultMasked = true, ...props }) {
    const [showPassword, setShowPassword] = useState(!defaultMasked);
    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev)
    }
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    }
    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    }
    return (
        <TextField
            {...props}
            id="filled-adornment-password"
            type={showPassword ? 'text' : 'password'}
            InputProps={{
                endAdornment:
                <InputAdornment position="end">
                    <IconButton
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        onMouseUp={handleMouseUpPassword}
                        edge="end"
                    >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                </InputAdornment>
            }}
        />
    )
}

